export default __webpack_public_path__ + "static/media/Devildick.0beb064b.PNG";